import React from 'react';
import MainButton from '../MainButton/MainButton';
import AuxiliaryText from '../Typography/AuxiliaryText';
import { useLoginActionService, LOGIN_SCENARIOS } from '../../../services/LoginActionService';

const AuthButtons = ({
  variant = 'desktop', // 'desktop' or 'mobile'
  onSignIn,
  onSignUp,
  onRequestQuote,
  className = '',
  showSignIn = true,
  showSignUp = true,
  showRequestQuote = true,
  hoverColor = 'hover:text-primaryblue',
  currentPath,
  auth
}) => {
  const loginActionService = useLoginActionService();
  const buttonClasses = {
    desktop: {
      container: 'flex items-center gap-6',
      signIn: 'cursor-pointer px-2 py-1',
      signUp: 'cursor-pointer px-2 py-1',
      requestQuote: ''
    },
    mobile: {
      container: 'grid grid-cols-1',
      signIn: 'mb-1 cursor-pointer px-2 py-2 rounded-md text-center',
      signUp: 'mb-6 cursor-pointer px-2 py-2 rounded-md text-center',
      requestQuote: ''
    }
  };

  const classes = buttonClasses[variant];

  return (
    <div className={`${classes.container} ${className}`}>
      {showSignIn && (
        <span
          className={`${classes.signIn} ${hoverColor}`}
          onClick={() => {
            console.log('Login button clicked');
            // Use header login scenario
            loginActionService.handleLoginTrigger(LOGIN_SCENARIOS.HEADER_LOGIN.id, {
              setSignIn: onSignIn,
              currentPath,
              auth
            });
          }}
        >
          <AuxiliaryText variant="NavigationText">
            Log in
          </AuxiliaryText>
        </span>
      )}

      {showSignUp && (
        <span
          className={`${classes.signUp} ${hoverColor}`}
          onClick={onSignUp}
        >
          <AuxiliaryText variant="NavigationText">
            Sign up
          </AuxiliaryText>
        </span>
      )}

      {showRequestQuote && (
        <MainButton
          variant="large"
          onClick={onRequestQuote}
          className={classes.requestQuote}
        >
          Get Quotes
        </MainButton>
      )}
    </div>
  );
};

export default AuthButtons; 